/**
 * RAM — Retail Account Maintenance module entry.
 * See `./routes.tsx` + `./RamLanding.tsx`.
 */
import './ram.css';
import { RamRoutes } from './routes';

export default function RAM(): JSX.Element {
  return <RamRoutes />;
}
